<template>
  <div id="userLayout">
    <div style="height: 70px;background-color: #454341;display: flex;align-items: center;padding-left: 40px;">
      <img :src="logoUrl"/>
    </div>
    <div>
      <route-view></route-view>
    </div>
  </div>
</template>

<script>
  import RouteView from './RouteView'
  import logoUrl from '@/assets/logo.png'
export default {
  components:{
    RouteView
  },
  data () {
    return {
      logoUrl
    }
  },

  mounted () {
  },

  methods: {

  }

}
</script>
<style>

</style>
